import React, { Component, Fragment } from 'react';
import DEFINE, { HOMESTAY as ENUM_HOMESTAY, PATHS, FEATURE_FLAGS, CACHE_HOTEL_SEARCH_TYPE } from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import Homestay from '../../../../models/Homestay.js';
import { Button, Icon, HomestayRate, Modal } from 'antd';
import HomestayList from './HomestayList';
import moment from 'moment'
import Ripple from '../../common/component/Ripple';
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect';
import Wrapper from 'containers/backend/common/component/Wrapper';

const { confirm } = Modal;

let permisionActions = [];
let permissionHomestayRate = [];
export default class Homestays extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.homestayState.pageSize,
                pageIndex: this.props.homestayState.pageIndex,
            },
            visibleClearCache: false,
            typeClearCache: 1,
        };
    }

    showModalClearCache = () => {
        this.setState({
            visibleClearCache: true,
        });
    };

    handleClearCacheOk = () => {
        this.props.clearCache(this.state.typeClearCache);
        this.setState({
            visibleClearCache: false,
        });
    };

    handleClearCacheCancel = () => {
        this.setState({
            visibleClearCache: false,
        });
    };

    onChangeType = (value) => {
        this.setState({
            typeClearCache: value
        })
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.HOMESTAY);
        permissionHomestayRate = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        this.props.getListHomestays(this.state.filters);
    }

    showConfirmSync = () => {
        const { t } = this.props;
        confirm({
            title: t('item.homestayRate.titleSyncAll'),
            content: t('item.homestayRate.messageSyncAll'),
            onOk: () => {
                this.props.syncHomestayRatesAllHomestay()
            },
            onCancel() { },
            okText: t(`action.sync`),
            cancelText: t(`action.cancel`)
        });
    }

    render() {
        const { t } = this.props;
        const { isFetching, isFetchClearCache, totalCount, totalPage, pageIndex, pageSize, homestays } = this.props.homestayState;
        const { isFetchSync, isFetchSyncAll } = this.props.homestayRateState
        const { visibleClearCache, typeClearCache } = this.state;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'homestays'}
                        titleHeader={t('navigation.homestays')}
                        componentRight={
                            <Fragment>
                                <Wrapper style={{ display: 'flex' }}>
                                    <Wrapper>
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="delete"
                                                loading={isFetchClearCache}
                                                onClick={this.showModalClearCache}
                                                className='btn btn-primary mr-3'
                                            >
                                                {t(`action.clearCache`)}
                                            </Button>
                                        </Ripple>
                                        <Modal
                                            title={t('item.homestayRate.clearCache')}
                                            visible={visibleClearCache}
                                            onOk={this.handleClearCacheOk}
                                            onCancel={this.handleClearCacheCancel}
                                            okText={t(`action.clearCache`)}
                                            cancelText={t(`action.cancel`)}
                                        >
                                            <AntSelect className="select-lengthOfTour"
                                                showArrow showSearch
                                                value={typeClearCache}
                                                onChange={(value) => this.onChangeType(value)}
                                                style={{ width: '100%' }}
                                                filterOption={this.selectFilterSearch}
                                            >
                                                {CACHE_HOTEL_SEARCH_TYPE.map((type) => (
                                                    <AntOption key={type.value} value={type.value}>
                                                        {type.lable}
                                                    </AntOption>
                                                ))}
                                            </AntSelect>
                                        </Modal>
                                    </Wrapper>
                                    {/* {
                                        permissionHomestayRate && permissionHomestayRate.allowSync &&
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="sync"
                                                loading={isFetchSyncAll}
                                                onClick={this.showConfirmSync}
                                                className='btn btn-primary mr-3'
                                            >
                                                {t(`action.sync`)}
                                            </Button>
                                        </Ripple>
                                    }
                                    {
                                        permisionActions && permisionActions.allowCreate &&
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Link to={PATHS.HOMESTAY.CREATE.path}
                                                className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                        </Ripple>
                                    } */}
                                </Wrapper>
                            </Fragment>
                        }
                    />
                    <HomestayList loading={isFetching}
                        permisions={permisionActions}
                        permissionHomestayRate={permissionHomestayRate}
                        homestays={homestays}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteHomestay={this.onDeleteHomestay}
                        syncHomestayRates={this.props.syncHomestayRates}
                        isFetchSync={isFetchSync}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });

        this.props.getListHomestays(newFilters);
    };

    onDeleteHomestay = (homestayItem) => {
    }

    onChangeLanguage = (language) => {
        this.props.getListHomestays(this.state.filters)
    }


}
